import { ROUTE } from "../../routes";
import { StoreKey } from "../../configs/api";
export const goBack = async (action, _datastore, { navigateToBase, asyncStorage }) => {
    console.warn("**** goBack Action Triggered ****", action);
    await asyncStorage.set(StoreKey.U_DATA, null);
    await asyncStorage.set(StoreKey.LEAD_TOKEN, null);
    navigateToBase(ROUTE.CHECK_LIMIT_MFC_INIT);
};
